import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export const adminOfficesApi = (token) => {
  const h = { headers: { Authorization: `Bearer ${token}` } };
  const O = `${API}/api/admin/offices`;
  const d = (r) => r.data;
  return {
    practices: () => axios.get(`${O}/practices`, h).then(d),
    practice: (pid) => axios.get(`${O}/practices/${pid}`, h).then(d),
    addOffice: (pid, body) => axios.post(`${O}/practices/${pid}/offices`, body, h).then(d),
    editOffice: (pid, oid, body) => axios.patch(`${O}/practices/${pid}/offices/${oid}`, body, h).then(d),
    closeOffice: (pid, oid) => axios.post(`${O}/practices/${pid}/offices/${oid}/close`, {}, h).then(d),
    reopenOffice: (pid, oid) => axios.post(`${O}/practices/${pid}/offices/${oid}/reopen`, {}, h).then(d),
    movePatients: (pid, oid, fromOfficeId) => axios.post(`${O}/practices/${pid}/offices/${oid}/patients`, { fromOfficeId }, h).then(d),
    setLimit: (pid, limit) => axios.put(`${O}/practices/${pid}/limit`, { limit }, h).then(d),
    setStaffOffice: (pid, uid, officeId) => axios.put(`${O}/practices/${pid}/staff/${uid}/office`, { officeId }, h).then(d),
    setPlan: (pid, tier, status) => axios.post(`${API}/api/admin/billing/set-plan`, { practice_id: pid, tier, status: status || null, note: 'Changed in Admin > Offices & Plans' }, h).then(d),
    inquiries: () => axios.get(`${API}/api/admin/enterprise-inquiries`, h).then(d),
    updateInquiry: (id, body) => axios.patch(`${API}/api/admin/enterprise-inquiries/${id}`, body, h).then(d),
    deleteInquiry: (id) => axios.delete(`${API}/api/admin/enterprise-inquiries/${id}`, h).then(d),
  };
};

export const errMsg = (e) => e?.response?.data?.detail || e?.message || 'Something went wrong';

export const TIERS = [['essential', 'Essential'], ['professional', 'Professional'], ['enterprise', 'Enterprise (DSO)'], ['grandfather', "Founder's Plan"]];
